module.exports = [
  ...require('./_toSplit/spellRawList_PHB'),

  ...require('./a'),
  ...require('./b'),
  ...require('./c'),
  ...require('./d'),
  ...require('./e'),
  ...require('./f'),
  ...require('./g'),
  ...require('./l'),
  ...require('./m'),
  ...require('./h'),
  ...require('./p'),
  ...require('./r'),
  ...require('./s'),
  ...require('./t'),
  ...require('./w'),
  ...require('./z'),
]
